export const PHONE_DISPLAY = "+971 54 771 4890";
export const PHONE_TEL = "tel:+971547714890";
export const WHATSAPP_URL = "https://wa.me/971547714890";
export const CALENDAR_URL = "https://cal.com/charbel-moubarak-4alnjl/30min";
export const INSTAGRAM_URL = "https://www.instagram.com/moubarak.charbel/";
export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@Charbel-Moubarak?sub_confirmation=1";

export const EPISODES = [
  { id: "5tp2GP7mOMs", ep: { en: "Episode 08", ar: "الحلقة 08" }, title: { en: "Auditing Billion-Dollar Master Communities with Kseniia (Arada)", ar: "تدقيق المجتمعات الفاخرة بمليارات الدولارات مع كسينيا (أرادَى)" } },
  { id: "owejmFHKQXE", ep: { en: "Episode 07", ar: "الحلقة 07" }, title: { en: "Auditing Elite Luxury with Joya Ghrair (Ohana Development)", ar: "تدقيق الفخامة الراقية مع جويا غرير (أوهانا للتطوير)" } },
  { id: "ziqpuxwIfsc", ep: { en: "Episode 06", ar: "الحلقة 06" }, title: { en: "The Mechanics of Scaling a Developer with Michael Francis (Wadan)", ar: "آليات توسيع شركة التطوير مع مايكل فرانسيس (وادن)" } },
  { id: "2VnPUfdhPfE", ep: { en: "Episode 05", ar: "الحلقة 05" }, title: { en: "Branded Residences & Boutique Value with Ali (Gulf Land)", ar: "السكنيات الفندقية والقيمة البوتيكية مع علي (جلف لاند)" } },
  { id: "o3tsfD1aHlE", ep: { en: "Episode 04", ar: "الحلقة 04" }, title: { en: "Is RAK the New Luxury Capital? with Albina", ar: "هل رأس الخيمة هي العاصمة الفاخرة الجديدة؟ مع ألبينا" } },
  { id: "xLpwyXjMdY0", ep: { en: "Episode 03", ar: "الحلقة 03" }, title: { en: "The Reality of High-Volume Real Estate with Bassma RM (Danube)", ar: "واقع العقارات عالية الحجم مع بسمة (دانوب)" } },
  { id: "hCggCEuY4CE", ep: { en: "Episode 02", ar: "الحلقة 02" }, title: { en: "Luxury Assets & Investment Data with Maria (DAMAC)", ar: "الأصول الفاخرة وبيانات الاستثمار مع ماريا (داماك)" } },
  { id: "AdWEgTh8AAY", ep: { en: "Episode 01", ar: "الحلقة 01" }, title: { en: "The Binghati Secret: How They Sell Out in Hours", ar: "سر بنغاطي: كيف تُباع المشاريع في ساعات" } },
  { id: "APdqAEWxNBg", ep: { en: "Official Teaser", ar: "الإعلان الرسمي" }, title: { en: "The Sales Drive: Dubai Real Estate Unfiltered", ar: "ذا سايلز درايف: عقارات دبي بلا فلاتر" } },
];

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1462007895615-c8c073bebcd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMHNreWxpbmUlMjBuaWdodCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODYyNzMyODN8MA&ixlib=rb-4.1.0&q=85",
  portrait: "/images/charbel-portrait.webp",
  gold: "/images/charbel-gold.webp",
  dark: "/images/charbel-dark.webp",
  penthouse:
    "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwZW50aG91c2UlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODYyNzMyODN8MA&ixlib=rb-4.1.0&q=85",
  condo:
    "https://images.unsplash.com/photo-1565623833408-d77e39b88af6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwZW50aG91c2UlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODYyNzMyODN8MA&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.unsplash.com/photo-1497215728101-856f4ea42174?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwb2ZmaWNlJTIwc3BhY2V8ZW58MHx8fHwxNzg2MjczMjgzfDA&ixlib=rb-4.1.0&q=85",
  officeMeeting:
    "https://images.unsplash.com/photo-1559136555-9303baea8ebd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwb2ZmaWNlJTIwc3BhY2V8ZW58MHx8fHwxNzg2MjczMjgzfDA&ixlib=rb-4.1.0&q=85",
  villaInterior:
    "https://images.unsplash.com/photo-1735146071436-4ceb5f8c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwZW50aG91c2UlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODYyNzMyODN8MA&ixlib=rb-4.1.0&q=85",
};

export const PROPERTIES = [
  {
    id: "damac-islands",
    dev: "damac",
    name: "DAMAC Islands",
    location: { en: "Dubailand", ar: "دبي لاند" },
    price: { en: "AED 2.25M – 5.5M+", ar: "2.25 – 5.5+ مليون درهم" },
    type: { en: "4–5 BR Luxury Townhouses & Villas", ar: "تاون هاوس وفلل فاخرة 4–5 غرف" },
    completion: { en: "2027 – 2028", ar: "2027 – 2028" },
    features: { en: "Seychelles, Mauritius, Bora Bora & Maldives clusters — lagoons, private beaches, water parks, floating cabanas", ar: "جزر سيشل وموريشيوس وبورا بورا والمالديف — بحيرات، شواطئ خاصة، حدائق مائية، كبائن عائمة" },
    about: { en: "Dubai's most talked-about tropical master community — island clusters named after Seychelles, Mauritius, Bora Bora and the Maldives, with over 3,000 units sold in a record AED 10B launch.", ar: "أشهر مجتمع استوائي متكامل في دبي — جزر تحمل أسماء سيشل وموريشيوس وبورا بورا والمالديف، مع أكثر من 3,000 وحدة بيعت في إطلاق قياسي بقيمة 10 مليارات درهم." },
    payment: { en: "75/25 · 10% down", ar: "75/25 · دفعة أولى 10%" },
    visa: true,
    image: "/images/project-damac-islands.webp",
  },
  {
    id: "mercedes-benz-places",
    dev: "binghatti",
    name: "Mercedes-Benz Places by Binghatti",
    location: { en: "Dubai", ar: "دبي" },
    price: { en: "AED 1.6M – 8M+", ar: "1.6 – 8+ مليون درهم" },
    type: { en: "Branded Luxury Apartments & Penthouses", ar: "شقق وبنتهاوس فاخرة بعلامة مرسيدس-بنز" },
    completion: { en: "2027 – 2029", ar: "2027 – 2029" },
    features: { en: "World's first Mercedes-Benz branded city — private car lifts, smart-home tech, sustainable design", ar: "أول مدينة في العالم بعلامة مرسيدس-بنز — مصاعد خاصة للسيارات، منزل ذكي، تصميم مستدام" },
    about: { en: "The world's first Mercedes-Benz branded city — an AED 8.2B landmark where automotive design language meets smart-home living, launched January 2026.", ar: "أول مدينة في العالم بعلامة مرسيدس-بنز — مشروع بقيمة 8.2 مليار درهم تلتقي فيه لغة تصميم السيارات بالمنزل الذكي، أُطلق في يناير 2026." },
    payment: { en: "Construction-linked", ar: "مرتبطة بمراحل الإنشاء" },
    visa: true,
    image: "/images/project-mercedes-places.webp",
  },
  {
    id: "sobha-riverside-crescent",
    dev: "sobha",
    name: "Sobha Hartland II — Riverside Crescent",
    location: { en: "MBR City · Nad Al Sheba", ar: "مدينة محمد بن راشد · ند الشبا" },
    price: { en: "AED 1.14M – 2.5M", ar: "1.14 – 2.5 مليون درهم" },
    type: { en: "1–2 BR Waterfront Apartments", ar: "شقق على البحيرة بغرفة أو غرفتين" },
    completion: { en: "Q1 2027 – Q1 2028", ar: "الربع الأول 2027 – 2028" },
    features: { en: "Swimmable lagoon, private beach, boardwalk, 30% green space, 360° city views", ar: "بحيرة صالحة للسباحة، شاطئ خاص، ممشى، 30% مساحات خضراء، إطلالات 360°" },
    about: { en: "Lagoon-front towers inside Sobha's MBR City master community — a swimmable lagoon, private beach and 30% green space, minutes from Downtown Dubai.", ar: "أبراج على البحيرة داخل مجتمع شوبا في مدينة محمد بن راشد — بحيرة صالحة للسباحة وشاطئ خاص و30% مساحات خضراء، على بعد دقائق من داون تاون دبي." },
    payment: { en: "60/40 flexible", ar: "60/40 مرنة" },
    visa: true,
    image: "/images/project-sobha-riverside.webp",
  },
  {
    id: "vela-viento",
    dev: "omniyat",
    name: "VELA VIENTO by Omniyat",
    location: { en: "Business Bay", ar: "الخليج التجاري" },
    price: { en: "AED 27.6M+", ar: "27.6+ مليون درهم" },
    type: { en: "Ultra-Luxury Apartments & Penthouses", ar: "شقق وبنتهاوس فائقة الفخامة" },
    completion: { en: "Q3 2027", ar: "الربع الثالث 2027" },
    features: { en: "Dorchester Collection standard, Omniyat design excellence, premium finishes", ar: "بمعايير دورشستر كولكشن وتميّز تصميم أمنيات وتشطيبات فاخرة" },
    about: { en: "Omniyat's sculptural twin tower on the Business Bay canal — Dorchester Collection-standard living, with construction already underway.", ar: "برج أمنيات المنحوت على قناة الخليج التجاري — معيشة بمعايير دورشستر كولكشن، وأعمال الإنشاء جارية بالفعل." },
    payment: { en: "5/55/40", ar: "5/55/40" },
    visa: true,
    image: "/images/project-vela-viento.webp",
  },
  {
    id: "the-vela-dorchester",
    dev: "omniyat",
    name: "The VELA, Dorchester Collection",
    location: { en: "Business Bay", ar: "الخليج التجاري" },
    price: { en: "AED 30M – 43.3M+", ar: "30 – 43.3+ مليون درهم" },
    type: { en: "Ultra-Luxury Apartments, Duplexes & Penthouses", ar: "شقق ودوبلكسات وبنتهاوس فائقة الفخامة" },
    completion: { en: "Q4 2027 – Q1 2028", ar: "الربع الرابع 2027 – الأول 2028" },
    features: { en: "Dorchester Collection management, Business Bay waterfront, high-end finishes", ar: "إدارة دورشستر كولكشن، على واجهة الخليج التجاري، تشطيبات راقية" },
    about: { en: "Managed by Dorchester Collection, The VELA pairs a Business Bay waterfront address with hotel-grade service and serene architecture.", ar: "بإدارة دورشستر كولكشن، يجمع ذا فيلا بين عنوان على واجهة الخليج التجاري وخدمات فندقية وتصميم هادئ." },
    payment: { en: "5/55/40", ar: "5/55/40" },
    visa: true,
    image: "/images/project-vela.webp",
  },
  {
    id: "alba-residences",
    dev: "omniyat",
    name: "The Alba Residences by Omniyat",
    location: { en: "Palm Jumeirah · The Crescent", ar: "نخلة جميرا · الهلال" },
    price: { en: "AED 43.3M – 44M+", ar: "43.3 – 44+ مليون درهم" },
    type: { en: "Ultra-Luxury Simplexes & Duplexes", ar: "سيمبلكس ودوبلكسات فائقة الفخامة" },
    completion: { en: "Q1 2028", ar: "الربع الأول 2028" },
    features: { en: "Panoramic sea views, Dorchester Collection services, premium amenities", ar: "إطلالات بانورامية على البحر، خدمات دورشستر كولكشن، مرافق فاخرة" },
    about: { en: "A low-rise beachfront jewel on the Palm's Crescent — panoramic sea views, premium amenities and Dorchester Collection services throughout.", ar: "جوهرة منخفضة الارتفاع على شاطئ هلال النخلة — إطلالات بانورامية على البحر ومرافق فاخرة وخدمات دورشستر كولكشن في كل ركن." },
    payment: { en: "5/55/40", ar: "5/55/40" },
    visa: true,
    image: "/images/project-alba.webp",
  },
];

export const TESTIMONIALS = [
  {
    quote: {
      en: "He made the impossible possible and helped me find my dream home. From the start, Charbel was always there with kindness, patience, and expert advice — his professionalism and commitment truly set him apart.",
      ar: "لقد جعل المستحيل ممكناً وساعدني في إيجاد منزل أحلامي. منذ البداية كان شاربل حاضراً دائماً بلطفه وصبره ونصائحه الخبيرة — احترافيته والتزامه يميّزانه حقاً.",
    },
    name: { en: "Noora Ghd", ar: "نورة غد" },
    role: { en: "Verified Google Review", ar: "مراجعة موثقة على جوجل" },
  },
  {
    quote: {
      en: "Charbel secured our DIFC office floor below market before launch. His off-plan instincts are unmatched — every projection he made has held true.",
      ar: "أمّن لنا شاربل طابق مكتبنا في مركز دبي المالي العالمي بأقل من سعر السوق قبل الإطلاق. حدسه في العقارات على المخطط لا يُضاهى — كل توقعاته تحققت.",
    },
    name: { en: "James W.", ar: "جيمس دبليو." },
    role: { en: "Portfolio Buyer, London", ar: "مشتري محافظ، لندن" },
  },
  {
    quote: {
      en: "From Beirut to Dubai, he handled everything remotely with total transparency. The handover was flawless and the unit already appreciated 22%.",
      ar: "من بيروت إلى دبي، تولى كل شيء عن بُعد بشفافية تامة. كان التسليم مثالياً وقد ارتفعت قيمة الوحدة 22% بالفعل.",
    },
    name: { en: "Rania K.", ar: "رانيا ك." },
    role: { en: "Investor, Beirut", ar: "مستثمرة، بيروت" },
  },
  {
    quote: {
      en: "As a first-time buyer I had endless questions. Charbel answered every one with patience and never once pushed a deal that wasn't right for me.",
      ar: "كمشترية لأول مرة كان لديّ أسئلة لا تنتهي. أجاب شاربل على كل واحد منها بصبر، ولم يدفعني ولو مرة نحو صفقة لا تناسبني.",
    },
    name: { en: "Layla H.", ar: "ليلى ح." },
    role: { en: "Homeowner, Dubai", ar: "مالكة منزل، دبي" },
  },
  {
    quote: {
      en: "He structured a three-unit commercial acquisition across two markets seamlessly. A true international operator who protects his clients first.",
      ar: "هيكل صفقة استحواذ على ثلاث وحدات تجارية في سوقين بسلاسة تامة. مشغّل دولي حقيقي يضع حماية عملائه أولاً.",
    },
    name: { en: "Chen W.", ar: "تشن دبليو." },
    role: { en: "Commercial Investor, Shanghai", ar: "مستثمر تجاري، شنغهاي" },
  },
];

export const GALLERY = [
  { src: IMAGES.heroBg, caption: { en: "Dubai skyline at dusk", ar: "أفق دبي عند الغسق" }, span: "md:col-span-2", pos: "object-center" },
  { src: "https://images.unsplash.com/photo-1518684079-3c830dcef090?q=85&w=1600&auto=format&fit=crop", caption: { en: "Burj Al Arab shoreline", ar: "واجهة برج العرب البحرية" }, span: "", pos: "object-center" },
  { src: IMAGES.penthouse, caption: { en: "Penthouse interiors", ar: "داخليات بنتهاوس فاخرة" }, span: "", pos: "object-center" },
  { src: "https://images.unsplash.com/photo-1722502831583-b4e93ecc6027?q=85&w=1600&auto=format&fit=crop", caption: { en: "Dubai Marina yachts", ar: "يخوت دبي مارينا" }, span: "", pos: "object-center" },
  { src: "https://images.unsplash.com/photo-1572101899722-41f73cdd8303?q=85&w=1600&auto=format&fit=crop", caption: { en: "Family life in the city", ar: "حياة العائلة في المدينة" }, span: "", pos: "object-center" },
  { src: IMAGES.villaInterior, caption: { en: "Signature villa living", ar: "معيشة الفلل الفاخرة" }, span: "", pos: "object-center" },
  { src: "https://images.unsplash.com/photo-1524234599372-a5bd0194758d?q=85&w=1600&auto=format&fit=crop", caption: { en: "Pool living with skyline views", ar: "مسابح بإطلالات على الأفق" }, span: "", pos: "object-center" },
  { src: "https://images.unsplash.com/photo-1528702748617-c64d49f918af?q=85&w=1600&auto=format&fit=crop", caption: { en: "Arabian coast mornings", ar: "صباحات الساحل العربي" }, span: "md:col-span-2", pos: "object-center" },
];
